import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  JsonApiParams,
  JsonApiResponse,
  serialize,
  objectToHttpParams,
  deserialize,
  CrudService,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpireVideo} from '@tisa-group/models';

@Injectable()
export class VideoService implements CrudService<UmpireVideo> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireVideo>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireVideo>> {
    return this.http
      .post(`/videos`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireVideo>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireVideo>> {
    return this.http
      .patch(`/videos/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
